/* eslint-disable no-param-reassign */
import produce from "immer";

import {
  LOAD_DRIVERS_REVENUES_REQUEST,
  LOAD_FLEET_REVENUES_REQUEST,
} from "../actions/revenueActions";

const initialState = {
  drivers: {},
  balance: 0,
};

const revenuesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DRIVERS_REVENUES_REQUEST: {
      const { drivers } = action.payload;
      return produce(state, (draft) => {
        draft.drivers = drivers;
      });
    }
    case LOAD_FLEET_REVENUES_REQUEST: {
      const { revenues } = action.payload;
      return produce(state, (draft) => {
        draft.revenues = revenues;
      });
    }

    default: {
      return state;
    }
  }
};

export default revenuesReducer;
